<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const FacebookIcon = getIcon("FacebookIcon");
</script>

{#if typeof FacebookIcon === 'string'}
	<img src={FacebookIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof FacebookIcon === 'function'}
	<svelte:component this={FacebookIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
